<template>
  <div class="details">
    <div v-if="modeLabel" class="detailRow">
      <span class="detailLabel">MODE</span>
      <span class="detailValue mono">{{ modeLabel }}</span>
    </div>
    <div v-if="config.soql" class="detailRow">
      <span class="detailLabel">SOQL</span>
      <span class="detailValue mono">{{ truncatedSoql }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  config: Record<string, any>
}>()

const truncatedSoql = computed(() => {
  const soql = (props.config.soql || '').trim()
  return soql.length > 80 ? soql.slice(0, 80) + '...' : soql
})

const modeLabel = computed(() => {
  const mode = props.config.mode
  if (mode === 'keep_matching') return 'Keep matching'
  if (mode === 'drop_matching') return 'Exclude matching'
  return ''
})
</script>

<style scoped>
.details {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.detailRow {
  display: flex;
  align-items: baseline;
  gap: var(--space-3);
}
.detailLabel {
  font-family: var(--font-sans);
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--tracking-wide);
  color: var(--color-text-tertiary);
  flex-shrink: 0;
}
.detailValue.mono {
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: var(--fs-xs);
  color: var(--color-text-secondary);
}
</style>
